import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c(VRow, [_c(VCol, [_c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "offset": 24,
      "title": _vm.$i18n_t('NiotaClassic.Devices.form.paketDatenVisualization'),
      "icon": "fa-info"
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "mb-0",
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('p', [_vm._v("\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.visualization_1')) + "\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.visualization_2')) + "\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.visualization_3')) + "\n            ")])])], 1)], 1)], 1)], 1), _vm.visualizeGraphsToggle ? _c(VRow, [_c(VCol, [_c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "offset": 24,
      "icon": "fa-chart-bar"
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [!_vm.isMobile ? _c('span', [_c(VBtn, {
          class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-${_vm.color}`,
          attrs: {
            "color": _vm.color,
            "disabled": _vm.limit === 10,
            "rounded": "",
            "text": ""
          },
          on: {
            "click": _vm.resetPackets
          }
        }, [_c(VIcon, {
          attrs: {
            "left": ""
          }
        }, [_vm._v("fal fa-backward")]), _vm._v("\n                " + _vm._s(_vm.$i18n_t('Common.reset')) + "\n            ")], 1)], 1) : _c('span', [_c(VBtn, {
          class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-${_vm.color}`,
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.reset'),
            "disabled": _vm.limit === 10,
            "icon": "",
            "info": "",
            "fab": "",
            "text": ""
          },
          on: {
            "click": _vm.resetPackets
          }
        }, [_c(VIcon, {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("fal fa-backward")])], 1)], 1)];
      },
      proxy: true
    }], null, false, 1750435764)
  }, [_c(VRow, _vm._l(_vm.graphKeys, function (key, index) {
    return _c(VCol, {
      key: index,
      staticClass: "pb-0 mb-0 charts-min-height",
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [!_vm.loadingGraph ? _c('niota-classic-charts-line', {
      staticStyle: {
        "display": "flex",
        "justify-content": "center"
      },
      attrs: {
        "height": 200,
        "chart-data-t": _vm.graphData[key]
      }
    }) : _c(VSkeletonLoader, {
      attrs: {
        "type": "table-row-divider@3"
      }
    })], 1);
  }), 1), _vm.showLoadMorePackets ? _c(VRow, [_c(VCol, {
    staticClass: "pb-0 mb-0",
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "title": _vm.$i18n_t('NiotaClassic.Devices.table.loadMore'),
      "loading": _vm.isLoading,
      "disabled": _vm.isLoading
    },
    on: {
      "click": function ($event) {
        return _vm.loadMorePackets();
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.loadMore')) + "\n              ")])], 1)])], 1) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };